import { ButtonTriggerEvent } from '../../../common/components';
import { HubFeed } from '../../../models/hub/hub.feed';

export class AssignTourModalActions {
    confirm: (event: ButtonTriggerEvent, locationFeeds: any) => void;
    cancel?: () => void;
}

export class AssignTourModalData {
    public hubName: string;
    public tourId: string;
    public regions: any;
    constructor(hubName: string, tourId: string, regions: any) {
        this.hubName = hubName;
        this.tourId = tourId;
        this.regions = regions;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/assign.tour.modal/assign.tour.modal.provider.ts